import PropTypes from 'prop-types';
import React from 'react';

import CurrentUserIcon from '@material-ui/icons/Person';
import LogoutIcon from '@material-ui/icons/PowerSettingsNew';

import AllInboxIcon from '@material-ui/icons/AllInbox';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import BrandingWatermarkIcon from '@material-ui/icons/BrandingWatermark';
import BurstModeIcon from '@material-ui/icons/BurstMode';
import CategoryIcon from '@material-ui/icons/Category';
import DvrIcon from '@material-ui/icons/Dvr';
import FilterHdrIcon from '@material-ui/icons/FilterHdr';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt';
import DashboardIcon from '@material-ui/icons/Dashboard';

const MenuItemIcon = (props) => {
  const { name } = props;

  let icon = null;
  switch (name) {
    case 'dashboard':
      icon = <DashboardIcon />;
      break;
    case 'user':
      icon = <CurrentUserIcon />;
      break;
    case 'packs':
      icon = <AllInboxIcon />;
      break;
    case 'scan':
    case 'templates':
      icon = <ViewQuiltIcon />;
      break;
    case 'montages':
      icon = <AspectRatioIcon />;
      break;
    case 'backgrounds':
      icon = <PhotoLibraryIcon />;
      break;
    case 'decorations':
      icon = <FilterHdrIcon />;
      break;
    case 'emoji':
      icon = <CategoryIcon />;
      break;
    case 'products':
      icon = <BurstModeIcon />;
      break;
    case 'orders':
      icon = <ShoppingBasketIcon />;
      break;
    case 'promoBanners':
      icon = <BrandingWatermarkIcon />;
      break;
    case 'test':
      icon = <FileCopyIcon />;
      break;

    case 'updateOrderAssets':
      icon = <DvrIcon />;
      break;
    case 'logout':
      icon = <LogoutIcon />;
      break;
    default:
      break;
  }

  return icon;
};

MenuItemIcon.propTypes = {
  name: PropTypes.string,
};

export default MenuItemIcon;
